import { render, staticRenderFns } from "./chat-window-item.vue?vue&type=template&id=651b98ea&scoped=true&"
import script from "./chat-window-item.vue?vue&type=script&lang=js&"
export * from "./chat-window-item.vue?vue&type=script&lang=js&"
import style0 from "./chat-window-item.vue?vue&type=style&index=0&id=651b98ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b98ea",
  null
  
)

export default component.exports